import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const meraki = defineConnector({
  identifier: "meraki",
  name: "Cisco Meraki",
  tagLine: "Cloud-managed networking and security",
  logo,
  protocol: "http",
  tags: ["it", "security"],
  defaultUrlPattern: () => "https://api\\.meraki\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Meraki Dashboard](https://dashboard.meraki.com/), go to **Organization → Settings**, enable API access, then go to your profile to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.meraki.com/api/v1/organizations",
  },
});
